module.exports = __webpack_public_path__ + "static/media/checkbox-checked.7aa4c719.svg";